module.exports = __webpack_public_path__ + "img/th.b012be52.png";